import React from 'react';
import { Routes, Route, NavLink } from 'react-router-dom';
import './App.css';

const portfolioCategories = [
  {
    category: 'dating apps',
    items: [
      {
        brand: 'hinge',
        link: 'https://www.instagram.com/p/DSD1v0GFKqP/?img_index=2',
        image: '/portfolio/dating-hinge-1.jpg',
        views: '37.6M',
        likes: '3M',
        comments: '9,976',
      },
      {
        brand: 'unfiltered dating',
        link: 'https://www.instagram.com/p/DYrp4xyDl72/?img_index=18',
        image: '/portfolio/dating-unfiltered-dating.jpg',
        views: '3.9M',
        likes: '257K',
        comments: '255',
      },
      {
        brand: 'hinge',
        link: 'https://www.instagram.com/reel/DSetDbbivlo/',
        image: '/portfolio/dating-hinge-2.jpg',
        views: '9.2M',
        likes: '898K',
        comments: '1,779',
      },
      {
        brand: 'breeze',
        link: 'https://www.instagram.com/reel/DMv9HCdu1Sa/',
        image: '/portfolio/dating-breeze.jpg',
        views: '5.1M',
        likes: '31.4K',
        comments: '510',
      },
      {
        brand: 'canva',
        link: 'https://www.instagram.com/reel/DSdTipzEuAl/',
        image: '/portfolio/dating-canva.jpg',
        views: '1.8M',
        likes: '145K',
        comments: '459',
      },
    ],
  },
  {
    category: 'artists',
    items: [
      {
        brand: 'ruth b',
        link: 'https://www.instagram.com/reel/DRDBdL-gVhv/',
        image: '/portfolio/artists-1.jpg',
        views: '4M',
        likes: '343K',
        comments: '1,247',
      },
      {
        brand: 'alessia cara',
        link: 'https://www.instagram.com/reel/DWPAkk5jtzl/',
        image: '/portfolio/artists-2.jpg',
        views: '1.1M',
        likes: '74K',
        comments: '215',
      },
    ],
  },
  {
    category: 'public figures',
    items: [
      {
        brand: 'mark kelly',
        link: 'https://www.instagram.com/p/DTQR_BaDtCI/',
        image: '/portfolio/publicfigures-mark-kelly.jpg',
        views: '5.4M',
        likes: '739K',
        comments: '3,177',
      },
      {
        brand: 'milly alcock',
        link: 'https://www.instagram.com/reel/DY2-ABFqDTE/',
        image: '/portfolio/publicfigures-milly-alcock.jpg',
        views: '1M',
        likes: '35K',
        comments: '189',
      },
      {
        brand: 'tova',
        link: 'https://www.instagram.com/reel/DLSx4D6vyBX/',
        image: '/portfolio/publicfigures-tova.jpg',
        views: '7M',
        likes: '359K',
        comments: '2,487',
      },
      {
        brand: 'chris williamson',
        link: 'https://www.instagram.com/reel/DU_B2d5jqx0/',
        image: '/portfolio/publicfigures-chris-williamson.jpg',
        views: '1.2M',
        likes: '50K',
        comments: '298',
      },
    ],
  },
  {
    category: 'fashion & beauty',
    items: [
      {
        brand: 'for the lovers',
        link: 'https://www.instagram.com/p/DSk4QJjkqRu/',
        image: '/portfolio/fashionbeauty-1.jpg',
        views: '2.3M',
        likes: '158K',
        comments: '1,831',
      },
    ],
  },
  {
    category: 'non-profit',
    items: [
      {
        brand: 'love has no labels',
        link: 'https://www.instagram.com/reel/DYnVGZLqXr4/',
        image: '/portfolio/nonprofit-1.jpg',
        views: '720K',
        likes: '42K',
        comments: '140',
      },
    ],
  },
];

function AboutSection() {
  return (
    <section className="section">
      <h1>about</h1>
      <img src="/headshot.png" alt="Preston Rakovsky" className="headshot" />
      <p>
        Preston Rakovsky is a content creator who explores human connection through conversations about love and vulnerability. He's been featured in NBC News, Hawaii News Now, and Bold Journey Magazine, and mentioned in Vogue and Dazed Magazine.
      </p>
      <p>
        He's a full-time content creator with 2.7+ million followers across platforms and 100M+ views per month on <a href="https://www.instagram.com/prestonrack/" target="_blank" rel="noopener noreferrer">Instagram</a> and <a href="https://www.tiktok.com/@prestonrack" target="_blank" rel="noopener noreferrer">TikTok</a>. What started as a social experiment in Central Park evolved into creating content about exploring the nuance of what love means to the world.
      </p>
      <p>
        Preston previously worked as a Software Engineer at Datadog for two years on the Distributed Storage Team on their Referential Data Platform. He holds a degree in Computer Science and Business from Northeastern University.
      </p>
    </section>
  );
}

function PressSection() {
  return (
    <section className="section">
      <h1>press</h1>
      <div className="press-items">
        <div className="press-item">
          <a href="https://www.vogue.in/content/gen-z-doesnt-need-better-rizz-they-need-more-curiosity" target="_blank" rel="noopener noreferrer">
            <span className="press-title">vogue</span>
            <span className="press-description">gen z doesn't need better rizz, they need more curiosity</span>
          </a>
        </div>
        <div className="press-item">
          <a href="https://www.nbcnews.com/video/social-media-project-that-shares-conversations-about-love-online-goes-viral-257688645809" target="_blank" rel="noopener noreferrer">
            <span className="press-title">nbc news</span>
            <span className="press-description">social media project that shares conversations about love online goes viral</span>
          </a>
        </div>
        <div className="press-item">
          <a href="https://www.dazeddigital.com/life-culture/article/69670/1/why-are-we-still-so-obsessed-with-love-languages" target="_blank" rel="noopener noreferrer">
            <span className="press-title">dazed magazine</span>
            <span className="press-description">why are we still so obsessed with love languages?</span>
          </a>
        </div>
        <div className="press-item">
          <a href="https://www.facebook.com/HawaiiNewsNow/videos/904543695408735" target="_blank" rel="noopener noreferrer">
            <span className="press-title">hawaii news now</span>
            <span className="press-description">preston rakovsky travels the world talking to people about love</span>
          </a>
        </div>
        <div className="press-item">
          <a href="https://boldjourney.com/meet-preston-rakovsky/" target="_blank" rel="noopener noreferrer">
            <span className="press-title">bold journey</span>
            <span className="press-description">meet preston rakovsky</span>
          </a>
        </div>
      </div>
    </section>
  );
}

function PortfolioSection() {
  return (
    <section className="section">
      <h1>portfolio</h1>
      <p className="portfolio-intro">brands we've showcased in our content.</p>
      <div className="portfolio-categories">
        {portfolioCategories.map((group) => (
          <div className="portfolio-category-group" key={group.category}>
            <h2 className="portfolio-category-title">{group.category}</h2>
            <div className="portfolio-items">
              {group.items.map((item, i) => (
                <div className="portfolio-item" key={i}>
                  <a href={item.link} target="_blank" rel="noopener noreferrer">
                    <img src={item.image} alt={`${item.brand} ad`} className="portfolio-image" />
                  </a>
                  <p className="portfolio-description">{item.brand}</p>
                  <span className="portfolio-numbers">
                    {[
                      item.views !== '—' && `${item.views} views`,
                      item.likes !== '—' && `${item.likes} likes`,
                      item.comments !== '—' && `${item.comments} comments`,
                    ]
                      .filter(Boolean)
                      .join(' · ') || 'stats coming soon.'}
                  </span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

function ContactSection() {
  return (
    <section className="section">
      <h1>contact</h1>
      <p>for all business and personal inquiries — <a href="mailto:preston@palettemgmt.com">preston@palettemgmt.com</a></p>
    </section>
  );
}

function App() {
  return (
    <div className="App">
      <nav className="nav">
        <NavLink to="/" end className={({ isActive }) => (isActive ? 'active' : '')}>
          about
        </NavLink>
        <NavLink to="/press" className={({ isActive }) => (isActive ? 'active' : '')}>
          press
        </NavLink>
        <NavLink to="/portfolio" className={({ isActive }) => (isActive ? 'active' : '')}>
          portfolio
        </NavLink>
        <NavLink to="/contact" className={({ isActive }) => (isActive ? 'active' : '')}>
          contact
        </NavLink>
      </nav>

      <main className="main">
        <div className="content">
          <Routes>
            <Route path="/" element={<AboutSection />} />
            <Route path="/press" element={<PressSection />} />
            <Route path="/portfolio" element={<PortfolioSection />} />
            <Route path="/contact" element={<ContactSection />} />
            <Route path="*" element={<AboutSection />} />
          </Routes>
        </div>
      </main>
    </div>
  );
}

export default App;
